module.exports = __webpack_public_path__ + "img/texiao-_0000s_0018_19.c52a7c61.png";